<template>
  <div>
    <div v-if="benchmark">
      <div class="bar-wrapper">
        <div class="bar-value">
          <span
            class="bar-value-pin"
            :style="{
              left: benchmarkModelled.value.positionPct + '%',
              color: benchmarkModelled.value.color
            }"
            ><span>{{ benchmarkModelled.value.value }}</span></span
          >
        </div>
        <div class="bar">
          <div
            class="bar-section"
            v-for="(item, index) in benchmarkModelled.sections"
            :key="'item-' + index"
            :style="{
              width: item.itemWidthPct + '%',
              left: item.itemPositionPct + '%',
              'background-color': item.itemColor
            }"
          >
            <div class="bar-section-wrapper">
              <span class="bar-section-value">{{ item.value }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-else class="no-data-available">
      No benchmarking data available.
    </div>
  </div>
</template>

<script>
export default {
  props: {
    marker: {
      type: Object,
      required: true
    }
  },
  methods: {},
  computed: {
    benchmark() {
      return this.$store.getters["TestsStore/benchmarkSingle"](this.marker.id);
    },
    benchmarkModelled() {
      // Map previous value into each range item
      const data = this.benchmark.range.map((item, prev) => ({
        ...item,
        prevValue: this.benchmark.range[prev > 0 ? prev - 1 : 0].value
      }));

      // Find max and min and delta
      const rangeMin = data.reduce(
        (min, p) => (p.value < min ? p.value : min),
        data[0].value
      );
      const rangeMax = data.reduce(
        (max, p) => (p.value > max ? p.value : max),
        data[0].value
      );
      const itemDelta = rangeMax - rangeMin;

      // Compute data needed to render sections of bar
      const sections = data.map(item => ({
        title: item.title,
        value: item.value,
        itemPosition: item.prevValue,
        itemWidth: item.value - item.prevValue,
        itemPositionPct: (100 * item.prevValue) / itemDelta,
        itemWidthPct: (100 * (item.value - item.prevValue)) / itemDelta,
        itemColor: item.color
      }));

      // Compute marker value vars
      const markerValue = parseFloat(this.marker.value);
      var markerColor = "#333333";
      for (var i = 0; i < sections.length; i++) {
        if (sections[i].value > markerValue) {
          markerColor = sections[i].itemColor;
          break;
        }
      }
      const value = {
        value: markerValue,
        positionPct: (100 * markerValue) / itemDelta,
        color: markerColor
      };

      return { sections, value };
    }
  }
};
</script>

<style lang="less" scoped>
@import "../../styles/vars";

@barHeight: @h1;
@dotRadius: @h2;
@dotStroke: 2px;
.bar-wrapper {
  width: 100%;
  position: relative;
  .bar-value {
    width: 100%;
    height: @h2;
    position: relative;
    .bar-value-pin {
      position: absolute;
      width: @dotRadius;
      height: @dotRadius;
      display: block;
      bottom: @hh;
      transform: translateX(-50%);
      z-index: 20;
      span {
        position: relative;
        width: 100%;
        height: 100%;
        display: block;
        color: inherit;
        font-size: 0;
        &:before {
          content: "";
          width: 100%;
          height: 100%;
          background-color: currentColor;
          border-radius: 50%;
          display: block;
          box-sizing: border-box;
          border: @dotStroke solid #fff;
          box-shadow: 0 2px 4px rgba(0, 0, 0, 0.4);
          z-index: 10;
          position: relative;
        }
        &:after {
          content: "";
          position: absolute;
          left: 0px;
          bottom: -@dotRadius;
          border-style: solid;
          border-width: @dotRadius / 2;
          border-color: #fff transparent transparent transparent;
          z-index: 2;
        }
      }
    }
  }
}
.bar {
  position: relative;
  width: 100%;
  margin-bottom: @h4;
  .bar-section {
    position: absolute;
    top: 0;
    border: 1px solid #fff;
    border-radius: @hh;
    .bar-section-wrapper {
      position: relative;
      height: @barHeight;
      width: 100%;
      span {
        position: absolute;
        top: @barHeight + @h1;
        right: 0;
        opacity: 0.3;
        transform: translateX(50%);
        font-size: 0.8rem;
      }
    }
    &:first-child {
      .bar-section-wrapper {
        span {
          right: auto;
          left: 0;
          transform: translateX(0);
        }
      }
    }
    &:last-child {
      .bar-section-wrapper {
        span {
          transform: translateX(0);
        }
      }
    }
  }
}

.no-data-available {
  color: #888;
  font-style: italic;
}
</style>
